module.exports = __webpack_public_path__ + "image/about_banner1.jpg";